module.exports = {"410172160":"石佛镇","410172360":"沟赵乡","410172560":"枫杨","410172561":"梧桐","410172562":"双桥"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410172.json
// module id = 1521
// module chunks = 0